/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .factory('AccountNotificationsInterceptor', [function(){
        return {
            response: function(response) {
                var
                    notification = {
                        frequency: response.resource.frequency,
                        notify_on_file_downloaded: response.resource.notify_on_file_downloaded,
                        notify_on_file_added: response.resource.notify_on_file_added,
                        notify_on_file_updated: response.resource.notify_on_file_updated,
                        notify_on_file_deleted: response.resource.notify_on_file_deleted,
                        notify_on_user_invite: response.resource.notify_on_user_invite,
                        notify_on_error: response.resource.notify_on_error
                    };

                return notification;
            }
        }
    }]);
 
 
